module.exports = __webpack_public_path__ + "img/mistral-ico.c0214570.svg";